<ion-content class="ion-padding">
<app-tipps></app-tipps>
<ion-button (click)="closeButtonClick()">Zurück</ion-button>
</ion-content>
